// src/data/tips.js
// Training tips database - add/edit tips here

export const trainingTips = [
   {
    id: 1,
    title: "Teach with Clarity, Not Volume",
    tip: "Say cues once, calmly, and mean them. If your dog doesn’t respond, simplify the situation or help them succeed instead of repeating louder. Clear communication builds reliability and keeps training fair.",
    icon: "🗣️"
  },
  {
    id: 2,
    title: "Reward Timing Matters Most",
    tip: "Deliver rewards within about one to two seconds of the desired behavior so your dog can clearly connect action to outcome. Late rewards accidentally pay for whatever they did afterward. Clean timing is one of the biggest performance upgrades you can give yourself.",
    icon: "⏱️"
  },
  {
    id: 3,
    title: "End Every Session on Success",
    tip: "Finish with an easy behavior your dog knows well and reward generously. Ending on a win keeps their confidence high and leaves them eager for the next session. Don’t let the last rep be the most frustrating one.",
    icon: "🌟"
  },
  {
    id: 4,
    title: "Consistency Creates Understanding",
    tip: "Use the same cue, tone, and body language for each behavior, and make sure everyone in the home does too. Inconsistent messaging forces your dog to guess and slows progress. Clarity feels safe to dogs.",
    icon: "🎯"
  },
  {
    id: 5,
    title: "Keep Sessions Short and Focused",
    tip: "Aim for focused 3–10 minute sessions instead of marathons. Stopping while your dog is still engaged keeps learning sharp and fun. Overlong sessions usually teach boredom or frustration, not brilliance.",
    icon: "⏳"
  },
  {
    id: 6,
    title: "Reward More Than You Correct",
    tip: "Make sure your dog hears 'Yes' far more than 'No.' A heavy reinforcement history for good choices creates a dog who wants to work with you. Corrections, when needed, land better on top of a strong positive foundation.",
    icon: "⚖️"
  },
  {
    id: 7,
    title: "Use Real-Life Rewards",
    tip: "Let real-world privileges like sniffing, greeting, getting on the couch, or being let off leash function as rewards for good behavior. This turns everyday life into training reps and makes your rules meaningful.",
    icon: "🎾"
  },
  {
    id: 8,
    title: "The Power of Marker Words",
    tip: "Use a marker like 'Yes!' or a clicker to mark the exact moment your dog gets it right. Follow the marker with a reward so it becomes a promise. This clarity speeds up learning and reduces confusion.",
    icon: "✨"
  },
  {
    id: 9,
    title: "Practice One Skill at a Time",
    tip: "When teaching something new, commit to that one concept for the session instead of bouncing around. Once your dog understands it, then mix with other skills. Focus prevents muddy communication.",
    icon: "🧩"
  },
  {
    id: 10,
    title: "Vary the Reward Value",
    tip: "Use everyday kibble for easy tasks and high-value treats for hard ones or distracting environments. Matching reward value to effort keeps your dog motivated and helps them push through challenges.",
    icon: "🥩"
  },
  {
    id: 11,
    title: "Reward Calm Thinking",
    tip: "Don’t only pay fast or flashy behaviors — also reinforce moments of quiet focus, stillness, or thoughtful response. You’re telling your dog that using their brain calmly is part of the job.",
    icon: "🧘‍♀️"
  },
  {
    id: 12,
    title: "Teach Patience Through Waiting",
    tip: "Use tiny pauses before meals, walks, or toys to teach your dog that good things come after a bit of self-control. Waiting becomes a habit, not a struggle, when rewarded consistently.",
    icon: "🚪"
  },
  {
    id: 13,
    title: "Prevent Before You Correct",
    tip: "Set up your home so your dog can’t easily rehearse bad behaviors — block access, pick things up, use crates or tethers. Prevention protects your relationship and makes 'no' less necessary.",
    icon: "🔒"
  },
  {
    id: 14,
    title: "Train in Micro Moments",
    tip: "Use real life as your training space: ask for a sit while you tie your shoe, a down while you work, or eye contact before stepping off a curb. These tiny reps add up faster than formal sessions.",
    icon: "☕"
  },
  {
    id: 15,
    title: "Reward Spontaneous Good Choices",
    tip: "Catch your dog doing something right without being asked — like settling quietly or ignoring a distraction — and reinforce it. You’re building a dog who chooses good behavior on their own.",
    icon: "📸"
  },
  {
    id: 16,
    title: "Start in a Quiet Space",
    tip: "Teach new behaviors where distractions are minimal so your dog has the best chance to understand. Once it’s solid there, slowly move to trickier environments. Don’t start at the hardest level.",
    icon: "🏠"
  },
  {
    id: 17,
    title: "Raise Criteria Slowly",
    tip: "Change only one variable at a time: either ask for a longer duration, more distance, or more distraction, not all three. Slow, thoughtful progression protects your dog’s confidence.",
    icon: "📐"
  },
  {
    id: 18,
    title: "Practice in Different Places",
    tip: "Dogs don’t automatically know 'sit' means 'sit' everywhere. Practice cues in different rooms, yards, and public spaces so behaviors truly generalize.",
    icon: "🌍"
  },
  {
    id: 19,
    title: "Don’t Chase, Trade",
    tip: "If your dog grabs something they shouldn’t, offer a better option instead of turning it into a chase game. Fair trades teach trust and reduce guarding.",
    icon: "🔄"
  },
  {
    id: 20,
    title: "Make Recall a Party",
    tip: "When your dog comes to you, make it worth it with praise, treats, or play. Never call them to punish or end all fun. Recall should always feel like a winning decision.",
    icon: "📣"
  },
  {
    id: 21,
    title: "Add Distance Gradually",
    tip: "For stays and recalls, start close, then add distance step by step. Each success at a new distance builds reliability without overwhelming your dog.",
    icon: "📏"
  },
  {
    id: 22,
    title: "Always Use a Release Word",
    tip: "Teach a consistent release cue like 'Free' so your dog knows when they’re done working. This prevents them from guessing and breaking positions early.",
    icon: "🔓"
  },
  {
    id: 23,
    title: "Practice Calm Handling",
    tip: "Regularly touch paws, ears, tail, collar, and harness areas while pairing with rewards. This builds trust and makes vet care, grooming, and daily handling easier.",
    icon: "🤲"
  },
  {
    id: 24,
    title: "Shape Behaviors in Steps",
    tip: "Reward small steps toward the final behavior instead of waiting for perfection. Shaping keeps your dog engaged and teaches them that trying is valuable.",
    icon: "🪜"
  },
  {
    id: 25,
    title: "End on Calm, Not Chaos",
    tip: "If things get messy, do one easy behavior, reward, and then stop. Ending in calm reinforces that training is safe and predictable, not exhausting.",
    icon: "🌿"
  },
  {
    id: 26,
    title: "Short and Frequent Wins",
    tip: "Use small bursts of success throughout the day: a quick recall here, a sit there. These micro sessions keep skills fresh without feeling like a chore.",
    icon: "🧠"
  },
  {
    id: 27,
    title: "Build a Rock-Solid Sit",
    tip: "Rehearse 'sit' in many contexts — at doors, for food, before play, during greetings. A reliable sit naturally replaces jumping, pushing, and darting.",
    icon: "🪑"
  },
  {
    id: 28,
    title: "Use Place for Peace",
    tip: "Teach your dog to go to a designated spot and relax there. It’s a powerful way to manage chaos during meals, guests, and busy household moments.",
    icon: "🛏️"
  },
  {
    id: 29,
    title: "Reward Eye Contact",
    tip: "Mark and reward when your dog chooses to make eye contact. Those check-ins show trust and are your lifeline in distracting environments.",
    icon: "👁️"
  },
  {
    id: 30,
    title: "Teach Touch Targeting",
    tip: "Train your dog to boop your hand with their nose on cue. This simple skill helps with recalls, redirection, and building engagement in shy or worried dogs.",
    icon: "🤝"
  },
  {
    id: 31,
    title: "Proof the Basics",
    tip: "Test sit, down, and stay around mild distractions like toys on the floor or people walking by. Proofing turns 'knows it' into 'can do it anywhere.'",
    icon: "🏞️"
  },
  {
    id: 32,
    title: "Build Duration Slowly",
    tip: "Ask your dog to hold a position for a bit longer each time, paying generously for success. Long, relaxed holds are built with many short wins.",
    icon: "⏲️"
  },
  {
    id: 33,
    title: "Fade the Lure",
    tip: "Start with food guiding your dog into position, then phase it out so your hand motion and verbal cue do the work. This prevents treat dependency.",
    icon: "🍬"
  },
  {
    id: 34,
    title: "Reward Relaxed Downs",
    tip: "Reinforce when your dog lies down with a loose body instead of a tense hover. You’re building a genuine 'off switch,' not just a position.",
    icon: "😴"
  },
  {
    id: 35,
    title: "Teach Leave It as Insurance",
    tip: "Begin with easy setups and gradually move to real-life temptations. A solid 'leave it' can prevent your dog from grabbing dangerous items.",
    icon: "🚫"
  },
  {
    id: 36,
    title: "Teach a Solid Drop It",
    tip: "Reward your dog for releasing objects so they learn that letting go makes good things happen. This keeps play safe and reduces resource guarding.",
    icon: "⬇️"
  },
  {
    id: 37,
    title: "Practice Wait at Thresholds",
    tip: "A calm pause before crossing streets, entering doors, or leaving the car builds safety and emotional control. Make waiting part of daily life.",
    icon: "🚷"
  },
  {
    id: 38,
    title: "Keep Leash Pressure Light",
    tip: "Teach your dog that soft leash pressure means 'follow me,' not 'fight me.' Gentle guidance instead of dragging protects your relationship.",
    icon: "🪢"
  },
  {
    id: 39,
    title: "Reward Loose Leash Moments",
    tip: "Any time the leash relaxes, mark it with praise or movement. You’re showing your dog that staying close and soft is the key to going places.",
    icon: "🦮"
  },
  {
    id: 40,
    title: "Stop Before Frustration",
    tip: "Quit a session before you or your dog get irritated. Ending too late teaches that training feels stressful instead of rewarding.",
    icon: "🎬"
  },
  {
    id: 41,
    title: "Turn Mistakes into Information",
    tip: "When your dog fails, see it as feedback about your setup, not defiance. Make it easier, guide, and reward the right version.",
    icon: "🔁"
  },
  {
    id: 42,
    title: "Pay for Effort",
    tip: "If your dog is genuinely trying, acknowledge it. Reinforcing effort keeps them engaged through the learning process.",
    icon: "🪙"
  },
  {
    id: 43,
    title: "Fade Rewards, Not Quality",
    tip: "As your dog improves, you can reward less frequently, but make sure the rewards you do give are still meaningful. Don’t go from steak to dust.",
    icon: "📉"
  },
  {
    id: 44,
    title: "Use Hand Signals",
    tip: "Back up your verbal cues with clear, simple hand signals. Many dogs respond even better to visual information, especially at a distance.",
    icon: "👋"
  },
  {
    id: 45,
    title: "Protect Your Cues",
    tip: "If your dog routinely ignores a word, rebuild it instead of shouting. Cues should predict clarity and consequences, not empty noise.",
    icon: "🧹"
  },
  {
    id: 46,
    title: "Teach Stay as a Mindset",
    tip: "Think of 'stay' as a calm mental state, not just a frozen pose. Pay for relaxed breathing, soft eyes, and stillness.",
    icon: "🧘"
  },
  {
    id: 47,
    title: "Give Words Meaning",
    tip: "Only use cues when you’re ready to follow through and help your dog get it right. Words without consistency lose value fast.",
    icon: "🗯️"
  },
  {
    id: 48,
    title: "Move with Purpose",
    tip: "Your dog reads your footsteps, shoulders, and direction. Intentional movement makes your cues clearer than any speech.",
    icon: "🚶‍♀️"
  },
  {
    id: 49,
    title: "One Cue, One Action",
    tip: "Teach your dog that one cue means one behavior. If they don’t respond, help them; don’t just pile on repeats.",
    icon: "🔊"
  },
  {
    id: 50,
    title: "Avoid Bribery",
    tip: "Lures are useful at the start, but if your dog only works when they see a treat, it’s time to fade the bribe. Rewards should confirm, not convince.",
    icon: "🍖"
  },
  {
    id: 51,
    title: "Observe Before You Command",
    tip: "Sometimes wait a second and see what your dog offers. You may catch a good decision you can reward without saying a word.",
    icon: "👀"
  },
  {
    id: 52,
    title: "Build Enthusiasm with Play",
    tip: "Mix tug, chase, or fetch between reps. When training predicts fun, your dog shows up with more heart and focus.",
    icon: "🥏"
  },
  {
    id: 53,
    title: "Teach an Off-Switch in Play",
    tip: "Add start and stop cues to tug or fetch so your dog learns to come down when asked. This prevents play from tipping into chaos.",
    icon: "🔋"
  },
  {
    id: 54,
    title: "Train in Real Environments",
    tip: "Practice skills in parking lots, parks, and store fronts once they’re solid at home. Functional obedience matters more than perfection in a vacuum.",
    icon: "🌆"
  },
  {
    id: 55,
    title: "Encourage Problem Solving",
    tip: "Let your dog think through simple tasks instead of micromanaging. Dogs who learn to think become more adaptable and confident.",
    icon: "🧠"
  },
  {
    id: 56,
    title: "Prioritize Functional Skills",
    tip: "Focus first on recall, leash skills, calm in the house, and handling. Fancy tricks are fun, but daily-life behaviors change everything.",
    icon: "🎓"
  },
  {
    id: 57,
    title: "Add Distractions Thoughtfully",
    tip: "Introduce mild distractions only after your dog is doing well. Always make sure they can still win.",
    icon: "📊"
  },
  {
    id: 58,
    title: "Use Calm Praise",
    tip: "You don’t need to scream with excitement for your dog to know you’re pleased. Warm, steady praise keeps arousal in a useful zone.",
    icon: "🙌"
  },
  {
    id: 59,
    title: "Pause Before You React",
    tip: "When your dog messes up, take a breath before responding. That tiny pause gives you space to choose teaching over snapping.",
    icon: "🌬️"
  },
  {
    id: 60,
    title: "Reset with Short Breaks",
    tip: "If your session gets messy, step away for a moment — water break, sniff break, breathe. Come back with a clearer head and easier rep.",
    icon: "☕"
  },
  {
    id: 61,
    title: "Practice Recall for Fun",
    tip: "Randomly call your dog during the day just to reward and release them. This keeps recall cue happy and sharp, not ominous.",
    icon: "🏃‍♀️"
  },
  {
    id: 62,
    title: "Build Recall Through Layers",
    tip: "Start where your dog can’t fail, then add movement, distractions, and distance slowly. Solid recall is built, not wished into existence.",
    icon: "🐿️"
  },
  {
    id: 63,
    title: "Train in Motion",
    tip: "Incorporate moving sits, downs, and focus while you walk. It keeps your dog tuned in and better prepared for real-world handling.",
    icon: "🚶‍♀️"
  },
  {
    id: 64,
    title: "Practice Calm Around Food",
    tip: "Teach your dog that food only appears when they’re not mugging you or the bowl. Calm behavior becomes the key that unlocks meals.",
    icon: "🍽️"
  },
  {
    id: 65,
    title: "Mind the Arousal Curve",
    tip: "When arousal gets too high, your dog’s thinking brain goes offline. Learn to spot when they’re getting wired and dial it down before asking for hard things.",
    icon: "📉"
  },
  {
    id: 66,
    title: "Use Clear Start and End Cues",
    tip: "Let your dog know when you’re actively training and when you’re done. This reduces nagging and helps them relax off-duty.",
    icon: "🔁"
  },
  {
    id: 67,
    title: "Use a Calm Tone for Direction",
    tip: "Firm but quiet direction is easier for dogs to follow than yelling. Your tone should feel like guidance, not danger.",
    icon: "🔇"
  },
  {
    id: 68,
    title: "Celebrate Micro Wins",
    tip: "When things feel slow, zoom in: one better rep, one second longer stay, one less pull. Noticing progress keeps you motivated and fair.",
    icon: "📈"
  },
  {
    id: 69,
    title: "Balance Work and Play",
    tip: "Sandwich tougher reps between play or affection. Effort plus fun keeps your dog emotionally invested.",
    icon: "⚽"
  },
  {
    id: 70,
    title: "Grow Confidence Through Success",
    tip: "If your dog is struggling, drop back to something easier so they can win. Confident dogs learn faster.",
    icon: "💪"
  },
  {
    id: 71,
    title: "Respect Individual Pacing",
    tip: "Different dogs progress at different speeds, even within the same breed. Adjust timelines instead of forcing them.",
    icon: "🐢"
  },
  {
    id: 72,
    title: "Use Boundaries as Comfort",
    tip: "Crates, pens, leashes, and 'place' aren’t punishments when used right. They create predictability and reduce pressure.",
    icon: "🚧"
  },
  {
    id: 73,
    title: "Don’t Compare Your Dog",
    tip: "Comparing your dog to others usually just creates frustration. Measure against yesterday’s version of your dog instead.",
    icon: "🧭"
  },
  {
    id: 74,
    title: "Train the Mind Too",
    tip: "Focus on teaching your dog how to think, wait, and handle mild frustration. Emotional skills are as important as obedience.",
    icon: "🧠"
  },
  {
    id: 75,
    title: "Mix Old and New Skills",
    tip: "Blend familiar cues with new ones so your dog gets confidence boosts during learning. It keeps momentum positive.",
    icon: "🔁"
  },
  {
    id: 76,
    title: "Take Training Outside",
    tip: "Walks are perfect times to practice check-ins, sits, and recalls. Real life is where your work needs to function.",
    icon: "🌳"
  },
  {
    id: 77,
    title: "Reward Calm at Doors",
    tip: "If your dog waits quietly instead of launching out, pay them. Calm exits are safer and more sustainable.",
    icon: "🚪"
  },
  {
    id: 78,
    title: "Choose Gentle Guidance",
    tip: "Use information, not intimidation. Gentle but consistent boundaries create a more stable, responsive dog than force ever will.",
    icon: "🤝"
  },
  {
    id: 79,
    title: "Use Breaks Inside Sessions",
    tip: "Tiny pauses between reps help your dog process. Silence and stillness are part of learning, not wasted time.",
    icon: "🕓"
  },
  {
    id: 80,
    title: "Watch Your Dog’s Eyes",
    tip: "Soft blinks and relaxed eyes show comfort; wide, hard eyes show stress. Adjust difficulty when you see tension building.",
    icon: "👁️"
  },
  {
    id: 81,
    title: "Be Patient with Puppies",
    tip: "Puppies are babies — they chew, forget, and get overstimulated fast. Use management, many naps, and gentle repetition instead of high expectations.",
    icon: "🐶"
  },
  {
    id: 82,
    title: "Say What You Want",
    tip: "Replace constant 'no' with clear instructions like 'sit,' 'off,' or 'this way.' Direction gives your dog a successful option.",
    icon: "🔄"
  },
  {
    id: 83,
    title: "Reward Calm Touch",
    tip: "Pet your dog when they’re relaxed and respectful, not when they’re flailing and demanding. This quietly reinforces better manners.",
    icon: "👐"
  },
  {
    id: 84,
    title: "Notice Your Own Body",
    tip: "Leaning over, grabbing, or looming can feel threatening. Standing sideways, soft knees, and gentle hands feel safer.",
    icon: "🧍"
  },
  {
    id: 85,
    title: "Plan Each Session",
    tip: "Go in knowing exactly what you’ll work on and how you’ll reward. A simple plan prevents chaotic training.",
    icon: "📝"
  },
  {
    id: 86,
    title: "Keep It Enjoyable",
    tip: "If you’re both miserable, nothing good is being learned. Adjust games, rewards, or criteria until training feels good again.",
    icon: "😄"
  },
  {
    id: 87,
    title: "Give Your Dog Space to Think",
    tip: "After giving a cue, wait instead of machine-gunning more cues. That little pause lets your dog process and choose correctly.",
    icon: "⏸️"
  },
  {
    id: 88,
    title: "Teach Out of the Kitchen",
    tip: "Use a cue to move your dog out of tight cooking spaces or doorways. This creates safety and less stress for everyone.",
    icon: "🍳"
  },
  {
    id: 89,
    title: "Build Resilience Gradually",
    tip: "Short waits, mild disappointments, and small challenges — handled kindly — grow your dog’s ability to cope with life.",
    icon: "🌱"
  },
  {
    id: 90,
    title: "End with Connection",
    tip: "After training, take a calm moment of touch or eye contact. You’re reminding your dog that working with you always leads back to safety and relationship.",
    icon: "🤍"
  },

  // 🧠 Behavior & Emotional Understanding (91–160)

  {
    id: 91,
    title: "Behavior Is Communication",
    tip: "Chewing, barking, hiding, lunging — it all means something. Instead of jumping to punishment, ask what need or emotion sits underneath.",
    icon: "🗣️"
  },
  {
    id: 92,
    title: "Reactivity Is Emotion, Not Defiance",
    tip: "A dog exploding at a trigger is usually scared, frustrated, or overstimulated. Treat it as an emotional problem to support, not a power struggle to win.",
    icon: "🌊"
  },
  {
    id: 93,
    title: "You Can’t Punish Away Fear",
    tip: "Correcting a fearful response might silence it in the moment, but it doesn’t make your dog feel safer. Focus on building positive associations and control instead.",
    icon: "🕊️"
  },
  {
    id: 94,
    title: "Reward Calm Curiosity",
    tip: "When your dog chooses to investigate something new without panicking, quietly pay that bravery. You’re reinforcing emotional stability.",
    icon: "🌱"
  },
  {
    id: 95,
    title: "Notice the Early Signs",
    tip: "Stiffness, closed mouth, whale eye, tucked tail, or panting can all be early stress signals. Respecting these whispers helps prevent the shout.",
    icon: "👀"
  },
  {
    id: 96,
    title: "Don’t Rush Comfort",
    tip: "Give your dog time to process new people, dogs, or objects. Let them choose when they’re ready instead of pushing them into contact.",
    icon: "🐾"
  },
  {
    id: 97,
    title: "Work Below Threshold",
    tip: "Find the distance or intensity where your dog notices but can still eat and respond. That’s your working zone; anything more is too much.",
    icon: "📉"
  },
  {
    id: 98,
    title: "Use Your Breath to Calm",
    tip: "When your dog tenses, consciously slow your breathing and loosen your shoulders. They’re constantly reading your body for safety cues.",
    icon: "🌬️"
  },
  {
    id: 99,
    title: "Offer Space, Not Pity",
    tip: "Instead of frantic reassurance when your dog is scared, just create space and move with quiet confidence. Safety speaks louder than 'It’s okay.'",
    icon: "🚶‍♀️"
  },
  {
    id: 100,
    title: "Celebrate Recovery",
    tip: "Measure progress by how quickly your dog returns to calm after a trigger. Reward that reset so bouncing back becomes their habit.",
    icon: "⏱️"
  },
  {
    id: 101,
    title: "Avoid Flooding",
    tip: "Dumping your dog into their worst fear rarely creates resilience; it usually creates shutdown or bigger reactions. Choose gradual, controlled exposure instead.",
    icon: "🌊"
  },
  {
    id: 102,
    title: "Distance Is Your Friend",
    tip: "Use distance from triggers freely and without guilt. A dog who can think is more important than a dog pretending to cope up close.",
    icon: "📏"
  },
  {
    id: 103,
    title: "Stay Neutral, Not Numb",
    tip: "Neutral means calm and steady — not cold. Your relaxed presence tells your dog there’s nothing to panic about.",
    icon: "🪷"
  },
  {
    id: 104,
    title: "Drop the Harsh Labels",
    tip: "Words like 'stubborn' or 'dominant' shut down curiosity. Describe what you see instead — that’s how you find the real solution.",
    icon: "🔍"
  },
  {
    id: 105,
    title: "Separate Emotion from Obedience",
    tip: "If your dog can’t sit, look, or take food, they’re too overwhelmed. Address the emotional overload first, then try the cue again later.",
    icon: "🧘"
  },
  {
    id: 106,
    title: "Reward Choosing to Walk Away",
    tip: "If your dog glances at a trigger and then chooses to disengage, pay that choice. You’re reinforcing self-control instead of reactivity.",
    icon: "🛣️"
  },
  {
    id: 107,
    title: "Teach 'Look at That'",
    tip: "Mark and reward your dog for calmly noticing a trigger, then looking back to you. This game turns scary things into predictable patterns.",
    icon: "👁️"
  },
  {
    id: 108,
    title: "Advocate in Public",
    tip: "Say 'No, thank you' to oncoming dogs or people if your dog isn’t comfortable. Protecting their space shows them you’re on their side.",
    icon: "🛡️"
  },
  {
    id: 109,
    title: "Predictability Soothes",
    tip: "Use consistent routes, rituals, and cues around stressful situations. Knowing what comes next helps sensitive dogs relax.",
    icon: "📆"
  },
  {
    id: 110,
    title: "Measure Tiny Improvements",
    tip: "Maybe your dog barked twice instead of ten times, or looked away once. Those little shifts are the building blocks of big change.",
    icon: "📈"
  },
  {
    id: 111,
    title: "Use Fewer Words in Stress",
    tip: "In charged moments, talking too much adds noise. Rely more on movement, distance, and one clear cue.",
    icon: "🔇"
  },
  {
    id: 112,
    title: "Let Them Observe Safely",
    tip: "Your dog doesn’t have to greet everyone. Watching the world from a safe distance is valid socialization.",
    icon: "👓"
  },
  {
    id: 113,
    title: "Look for Softness",
    tip: "Reward loose bodies, wiggly tails, and relaxed faces around triggers. Those signals tell you your work is paying off.",
    icon: "💞"
  },
  {
    id: 114,
    title: "Behavior Changes Day to Day",
    tip: "Stress, pain, hormones, or lack of sleep affect behavior. Don’t assume yesterday’s success guarantees today’s; reassess kindly.",
    icon: "🧭"
  },
  {
    id: 115,
    title: "Don’t Set Traps",
    tip: "Avoid manufacturing difficult situations 'to see what they’ll do.' Set them up to succeed so trust stays intact.",
    icon: "🚫"
  },
  {
    id: 116,
    title: "Use Calm Touch to Ground",
    tip: "When your dog is worried but reachable, slow, steady strokes along their body can help them settle. If touch agitates them, give space instead.",
    icon: "🖐️"
  },
  {
    id: 117,
    title: "Control the Setup",
    tip: "Work new behaviors in controlled conditions first: known dogs, known routes, known triggers at a distance. Stacked wins build resilience.",
    icon: "🌪️"
  },
  {
    id: 118,
    title: "Reinforce Quiet Observation",
    tip: "If your dog notices something and chooses not to bark or lunge, calmly mark and reward. That’s exactly the emotional control you want.",
    icon: "💰"
  },
  {
    id: 119,
    title: "Give Choices",
    tip: "Choices like 'move away,' 'stand behind me,' or 'look at me' help your dog feel less trapped. A dog with options is calmer.",
    icon: "🚶"
  },
  {
    id: 120,
    title: "Protect Their Bubble",
    tip: "Physically block or step between your dog and pushy greetings. Overriding their discomfort erodes trust.",
    icon: "🚧"
  },
  {
    id: 121,
    title: "Calm Is Contagious",
    tip: "Your steady breathing and relaxed posture tell your dog there is no emergency. Let your body send that message first.",
    icon: "🧘‍♂️"
  },
  {
    id: 122,
    title: "Avoid Emotional Whiplash",
    tip: "Swinging from yelling to over-coddling confuses your dog. Aim for steady, predictable responses instead.",
    icon: "⚖️"
  },
  {
    id: 123,
    title: "Let Them Sniff to Cope",
    tip: "Sniffing during stress is self-soothing. When safe, allow it — it helps your dog regulate instead of explode.",
    icon: "🌿"
  },
  {
    id: 124,
    title: "Stress Stacks",
    tip: "A vet visit, loud guests, and a strange dog in one day can overload your dog. Recognize stacked stress and lower demands accordingly.",
    icon: "🗓️"
  },
  {
    id: 125,
    title: "Recovery Walks",
    tip: "After tough days, choose quiet routes, longer sniffs, and very low expectations. Decompression time is part of behavior work.",
    icon: "🚶‍♂️"
  },
  {
    id: 126,
    title: "Understand Fear Periods",
    tip: "Puppies and adolescents may suddenly spook at normal things. Stay calm, avoid drama, and guide them gently through it.",
    icon: "🐶"
  },
  {
    id: 127,
    title: "Give Time to Process",
    tip: "When something startles your dog, pause. Let them look, sniff, and think instead of dragging them forward.",
    icon: "⏸️"
  },
  {
    id: 128,
    title: "More Isn’t Always Better",
    tip: "Hammering triggers over and over can make them worse. Aim for a few high-quality, under-threshold reps rather than endless exposure.",
    icon: "🔁"
  },
  {
    id: 129,
    title: "Reward Calm Around Noise",
    tip: "If a loud sound happens and your dog stays neutral or recovers quickly, mark and treat. You’re reinforcing resilience.",
    icon: "🔊"
  },
  {
    id: 130,
    title: "Redirect Over Punish",
    tip: "If your dog does something unwanted from stress, calmly guide them into a better behavior. Redirection teaches; punishment just suppresses.",
    icon: "➡️"
  },
  {
    id: 131,
    title: "Reinforce Stillness",
    tip: "Stillness after being triggered is your dog trying to self-regulate. Reward that pause to encourage control.",
    icon: "🧊"
  },
  {
    id: 132,
    title: "Use Simple Patterns",
    tip: "Repeating tiny routines like 'look at me → treat → step away' creates predictability around triggers. Brains love patterns.",
    icon: "🔁"
  },
  {
    id: 133,
    title: "Don’t 'Test' Their Limits",
    tip: "Purposely pushing them to see if they’ll react again is about your curiosity, not their growth. Protect their progress.",
    icon: "🚦"
  },
  {
    id: 134,
    title: "Pair Scary with Good",
    tip: "At a safe distance, pair mild versions of scary things with treats, play, or affection. Over time, the emotional meaning starts to shift.",
    icon: "🍗"
  },
  {
    id: 135,
    title: "Honor the Half-Life of Stress",
    tip: "Stress chemicals don’t disappear instantly. Give your dog real downtime after intense moments instead of stacking more challenges.",
    icon: "⏳"
  },
  {
    id: 136,
    title: "Protect the Cooldown",
    tip: "When your dog has just handled something big, don’t throw them right back into pressure. Let their system fully settle.",
    icon: "🪷"
  },
  {
    id: 137,
    title: "Be a Calm Anchor",
    tip: "Stand steady, breathe slowly, and avoid frantic movements when your dog is on edge. You’re the one stable thing they can lock onto.",
    icon: "⚓"
  },
  {
    id: 138,
    title: "Skip the Drama",
    tip: "Getting loud or emotional with a reactive dog usually escalates things. Keep your voice low and your body language boring.",
    icon: "🌬️"
  },
  {
    id: 139,
    title: "Desensitize in Tiny Steps",
    tip: "Slice scary triggers into the smallest versions: quieter, further away, slower. Only progress when your dog is truly relaxed.",
    icon: "🐾"
  },
  {
    id: 140,
    title: "Reward Calm Exposure",
    tip: "Each time your dog sees or hears something challenging and stays composed, quietly pay it. That’s gold.",
    icon: "🏗️"
  },
  {
    id: 141,
    title: "Use Movement as Relief",
    tip: "Stepping in an arc or turning away breaks tension better than standing and staring at triggers. Motion softens pressure.",
    icon: "🔄"
  },
  {
    id: 142,
    title: "Practice Looking Away Together",
    tip: "Normalize turning away from triggers instead of confronting them. You’re teaching your dog that avoidance is a smart, safe choice.",
    icon: "👩‍🤝‍👨"
  },
  {
    id: 143,
    title: "Soften Your Approach",
    tip: "For sensitive dogs, approach from the side, crouch slightly, and avoid direct staring. This body language feels safer.",
    icon: "🙇‍♀️"
  },
  {
    id: 144,
    title: "Build Calm Greetings",
    tip: "Rehearse low-key greetings with people and dogs your dog trusts. Reward sniffs, soft bodies, and choosing to disengage.",
    icon: "🙌"
  },
  {
    id: 145,
    title: "Filter the World",
    tip: "Don’t let every dog, person, or child interact. Curate your dog’s experiences so they meet more 'safe' than 'stressful.'",
    icon: "🧘‍♀️"
  },
  {
    id: 146,
    title: "Read the Whole Dog",
    tip: "Never judge behavior by one signal, like tail wagging. Look at the full body to understand how they truly feel.",
    icon: "👁️‍🗨️"
  },
  {
    id: 147,
    title: "Reward Independence",
    tip: "When your dog can chill in another room without anxiety, praise that. Emotional independence is healthy.",
    icon: "🌻"
  },
  {
    id: 148,
    title: "Check Your Posture",
    tip: "Towering, tense posture can accidentally intimidate. Try soft knees, turned shoulders, and slower movements instead.",
    icon: "🚶"
  },
  {
    id: 149,
    title: "Avoid Heavy-Handed Corrections",
    tip: "Harsh responses to stress-based behaviors teach your dog that you’re unsafe when they’re scared. Choose education over intimidation.",
    icon: "🩹"
  },
  {
    id: 150,
    title: "Don’t Take It Personally",
    tip: "Your dog’s reactivity or shutdown isn’t about disrespecting you. It’s about their nervous system needing help.",
    icon: "💬"
  },
  {
    id: 151,
    title: "Let Them Shake It Off",
    tip: "A full-body shake is your dog’s natural reset button. When you see it after stress, that’s them letting go.",
    icon: "💧"
  },
  {
    id: 152,
    title: "Use Routine to Heal",
    tip: "Predictable daily patterns reduce background anxiety. Sensitive dogs especially benefit from knowing what comes next.",
    icon: "🕰️"
  },
  {
    id: 153,
    title: "Build Frustration Tolerance",
    tip: "Practice short, achievable waits with rewards for staying composed. This helps your dog handle 'not yet' in real life.",
    icon: "🧩"
  },
  {
    id: 154,
    title: "Teach a Soft 'Easy' Cue",
    tip: "Pair 'Easy' with slowing down when things are already calm so it becomes a genuine calming signal later.",
    icon: "💬"
  },
  {
    id: 155,
    title: "Choose Calm Dog Friends",
    tip: "Match your dog with neutral, polite dogs for social time. The company they keep shapes their behavior.",
    icon: "🐕‍🦺"
  },
  {
    id: 156,
    title: "Watch the Recovery Speed",
    tip: "You may still see reactions, but if your dog settles faster than they used to, that’s real growth. Track that.",
    icon: "🕊️"
  },
  {
    id: 157,
    title: "Avoid Jump Scares",
    tip: "Alert sleeping, deaf, or blind dogs before touching them. Surprises create startle responses that are easy to avoid.",
    icon: "👣"
  },
  {
    id: 158,
    title: "Reinforce Checking In",
    tip: "If your dog looks to you when they’re unsure, mark and reward. You want them to ask you instead of deciding alone.",
    icon: "🧭"
  },
  {
    id: 159,
    title: "Accept That Change Takes Time",
    tip: "Long-standing fears or patterns don’t vanish in a week. Commit to the long game and keep stacking good reps.",
    icon: "⌛"
  },
  {
    id: 160,
    title: "See Progress, Not Perfection",
    tip: "Behavior work is messy, but if the trend line is improving, you’re doing it right. Don’t let one bad day erase twenty good ones.",
    icon: "🏁"
  },

  // 💞 Mindset & Relationship (161–220)

  {
    id: 161,
    title: "Connection Before Correction",
    tip: "A dog who feels safe and bonded with you will accept guidance more easily. Strengthen the relationship so redirection doesn’t feel like a threat.",
    icon: "🤝"
  },
  {
    id: 162,
    title: "Your Calm Leads",
    tip: "In any tense moment, your dog is scanning you for cues. If you stay composed and grounded, they have permission to settle too.",
    icon: "🧘"
  },
  {
    id: 163,
    title: "Breathe Before You Speak",
    tip: "A single deep breath can turn a reactive reaction into a thoughtful response. Practice pausing so you choose better words and timing.",
    icon: "🌬️"
  },
  {
    id: 164,
    title: "Guidance Over Control",
    tip: "Leading your dog means showing them what to do, not just what to stop doing. Dogs follow calm, confident guidance better than force.",
    icon: "🎯"
  },
  {
    id: 165,
    title: "Train the Relationship",
    tip: "Every interaction is either building or weakening trust. Approach training like a conversation with someone you care about.",
    icon: "❤️"
  },
  {
    id: 166,
    title: "Celebrate the Small Stuff",
    tip: "Not every day is dramatic progress. Notice tiny improvements — those are your stepping stones.",
    icon: "🌿"
  },
  {
    id: 167,
    title: "Mind Your Energy",
    tip: "If you’re rushing, angry, or tense, your dog feels it instantly. Reset yourself before expecting them to be settled.",
    icon: "⚡"
  },
  {
    id: 168,
    title: "Consistency Builds Trust",
    tip: "When your dog can predict your reactions, they feel safer and more secure. Erratic responses create anxiety.",
    icon: "🔁"
  },
  {
    id: 169,
    title: "Be Their Safe Place",
    tip: "Your dog should be able to lean into you when the world feels loud. That doesn’t mean rescuing from everything, but being stable through it.",
    icon: "⚓"
  },
  {
    id: 170,
    title: "See Training as Teamwork",
    tip: "You and your dog are on the same side solving life together. Dropping the 'me vs them' mindset instantly improves communication.",
    icon: "🤲"
  },
  {
    id: 171,
    title: "Listen with Your Eyes",
    tip: "Watch how your dog approaches, avoids, or hesitates. Their body often answers questions you haven’t asked yet.",
    icon: "👂"
  },
  {
    id: 172,
    title: "Reward Engagement",
    tip: "Every time your dog chooses you over a distraction, reinforce it. You’re making yourself the best option in the room.",
    icon: "🌟"
  },
  {
    id: 173,
    title: "Soft Eye Contact",
    tip: "Encourage brief, relaxed eye contact instead of hard staring contests. Gentle connection builds trust without pressure.",
    icon: "👁️"
  },
  {
    id: 174,
    title: "Calm Affection",
    tip: "Use slow, grounding touch instead of frantic petting to reward your dog. It keeps energy balanced instead of spiking it.",
    icon: "🤍"
  },
  {
    id: 175,
    title: "Predictability Feels Like Love",
    tip: "Showing up the same way, with steady boundaries and care, is one of the clearest ways dogs experience safety.",
    icon: "📆"
  },
  {
    id: 176,
    title: "Lead with Gratitude",
    tip: "Actively notice what you enjoy about your dog. It shifts your tone, patience, and creativity in training.",
    icon: "🙏"
  },
  {
    id: 177,
    title: "Presence Over Perfection",
    tip: "Your dog doesn’t care about perfect technique as much as they care that you’re actually there with them. Attention beats aesthetics.",
    icon: "📵"
  },
  {
    id: 178,
    title: "End on Connection",
    tip: "After structured work, let your dog know you’re good with them: soft words, a scratch, a shared breath. It closes the loop emotionally.",
    icon: "🤲"
  },
  {
    id: 179,
    title: "Be Fair",
    tip: "Never punish what you haven’t clearly taught or what your dog can’t control. Fairness keeps their trust intact.",
    icon: "⚖️"
  },
  {
    id: 180,
    title: "Patience Is a Skill",
    tip: "You won’t always feel patient, but you can practice it. Pausing, breathing, and reframing get easier with use.",
    icon: "🕰️"
  },
  {
    id: 181,
    title: "Consistency Beats Intensity",
    tip: "Five calm minutes daily will outperform one big dramatic effort. Long-term habits win.",
    icon: "⏱️"
  },
  {
    id: 182,
    title: "Honor Their Personality",
    tip: "Work with your dog’s natural traits instead of against them. Sensitive, bold, goofy — each needs a slightly different approach.",
    icon: "🌈"
  },
  {
    id: 183,
    title: "Repair After You Snap",
    tip: "If you lose your cool, reset the environment and your tone. Show your dog that calm you is back and reliable.",
    icon: "💫"
  },
  {
    id: 184,
    title: "Model Resilience",
    tip: "When things go sideways, show your dog that you can recover. They learn emotional flexibility by watching you handle life.",
    icon: "🌙"
  },
  {
    id: 185,
    title: "Play Like It Matters",
    tip: "Play is not a luxury; it’s a language. It builds trust, burns stress, and reminds your dog that you’re safe to be joyful with.",
    icon: "🎾"
  },
  {
    id: 186,
    title: "Use Freedom Thoughtfully",
    tip: "Offer new freedoms gradually as your dog proves responsible. Earned freedom feels better and creates less conflict.",
    icon: "🗝️"
  },
  {
    id: 187,
    title: "Lead with Empathy",
    tip: "Ask yourself how things feel from your dog’s point of view before reacting. Empathy sharpens your instincts.",
    icon: "💞"
  },
  {
    id: 188,
    title: "Reward the Try",
    tip: "Even if it’s not perfect, reward your dog when they’re genuinely trying to figure it out. You’re building a learner, not a robot.",
    icon: "🪙"
  },
  {
    id: 189,
    title: "Detach from Ego",
    tip: "Needing your dog to 'obey' to feel in control will wreck the relationship. Focus on communication, not winning.",
    icon: "🧠"
  },
  {
    id: 190,
    title: "Keep It Playful",
    tip: "A light joke or smile can break tension in training. Dogs relax when you do.",
    icon: "😄"
  },
  {
    id: 191,
    title: "Reconnect When Stuck",
    tip: "If training is spiraling, drop the exercise and do something easy or affectionate. Reset the relationship, then return to the work later.",
    icon: "🪷"
  },
  {
    id: 192,
    title: "Soft Confidence",
    tip: "You can be firm without being harsh. Calm, decisive energy is clearer and safer than intensity.",
    icon: "💧"
  },
  {
    id: 193,
    title: "Reward Honest Signals",
    tip: "If your dog shows discomfort instead of exploding, honor that communication. You want them to talk to you, not bottle it up.",
    icon: "💬"
  },
  {
    id: 194,
    title: "Blend Warmth and Boundaries",
    tip: "Dogs feel safest with both affection and clear rules. Too much of either alone leaves them off balance.",
    icon: "☯️"
  },
  {
    id: 195,
    title: "Be Predictable",
    tip: "Predictable human, predictable outcomes. Your dog should not have to guess which version of you they’re getting.",
    icon: "🕊️"
  },
  {
    id: 196,
    title: "Your Tone Trains Too",
    tip: "Even when they don’t know the words, they know how you say them. Let your tone carry calm authority.",
    icon: "🎶"
  },
  {
    id: 197,
    title: "Learn from Their Forgiveness",
    tip: "Dogs bounce back quickly when we do better. Use that as motivation to reset instead of spiraling in guilt.",
    icon: "🌤️"
  },
  {
    id: 198,
    title: "Let Silence Teach",
    tip: "Not every moment needs commentary. Quiet sometimes gives your dog the space to make a better choice.",
    icon: "🤫"
  },
  {
    id: 199,
    title: "Seek Understanding",
    tip: "Instead of 'Why won’t you?', ask 'What’s in your way?'. That mindset change opens solutions.",
    icon: "🧭"
  },
  {
    id: 200,
    title: "Safety Before Skills",
    tip: "A dog who feels emotionally and physically safe will learn any cue faster. Don’t skip that foundation.",
    icon: "🪺"
  },
  {
    id: 201,
    title: "Use Humor on Hard Days",
    tip: "When training goes sideways, laughing and trying again is often more productive than getting stern.",
    icon: "😂"
  },
  {
    id: 202,
    title: "Be Gentle When They Fail",
    tip: "Harsh reactions to confusion break trust. Calmly guide them toward the right answer instead.",
    icon: "💗"
  },
  {
    id: 203,
    title: "Praise Softly",
    tip: "Big, explosive praise can overstimulate sensitive dogs. Soft, sincere praise sinks in deeper.",
    icon: "🌸"
  },
  {
    id: 204,
    title: "Touch with Intention",
    tip: "Use long, slow strokes when you want to relax your dog, and avoid rapid, choppy petting that amps them up.",
    icon: "🤲"
  },
  {
    id: 205,
    title: "Balance Arousal Together",
    tip: "If your dog escalates, you de-escalate. Don’t join them on the emotional roller coaster.",
    icon: "⚖️"
  },
  {
    id: 206,
    title: "Walk in Partnership",
    tip: "Use walks as time to sync up: shared pace, shared attention. It’s moving meditation for both of you.",
    icon: "🚶‍♀️"
  },
  {
    id: 207,
    title: "Advocate Out Loud",
    tip: "Don’t be afraid to tell people 'Please don’t pet' or 'My dog needs space.' Clear advocacy protects your dog’s trust.",
    icon: "🛡️"
  },
  {
    id: 208,
    title: "Allow Healthy Autonomy",
    tip: "Give your dog appropriate choices, like which bed to use or which toy to carry. Agency builds confidence.",
    icon: "🌻"
  },
  {
    id: 209,
    title: "Repair Quickly",
    tip: "When there’s tension, don’t ignore it. Take a breath, slow down, and intentionally reset the vibe.",
    icon: "🕊️"
  },
  {
    id: 210,
    title: "Choose Empathy Over Ego",
    tip: "Ask, 'What does my dog need right now?' instead of 'How do I win this?'. That shift alone fixes a lot.",
    icon: "💞"
  },
  {
    id: 211,
    title: "See Beyond Labels",
    tip: "Words like 'reactive' or 'rescue' explain history, not destiny. Stay curious about who your dog is today.",
    icon: "🔍"
  },
  {
    id: 212,
    title: "Practice Shared Stillness",
    tip: "Sit together quietly without asking for tricks. Existing peacefully side by side is powerful relationship work.",
    icon: "🌾"
  },
  {
    id: 213,
    title: "Pay for Calm Companionship",
    tip: "If your dog hangs out near you calmly, slip them a reward sometimes. You’re reinforcing the dog everyone wants.",
    icon: "💰"
  },
  {
    id: 214,
    title: "Avoid Energy Ping-Pong",
    tip: "If your dog gets amped and you meet them at that same level, things spiral. One of you has to choose calm; that’s your job.",
    icon: "🎾"
  },
  {
    id: 215,
    title: "Check Your Intentions",
    tip: "Before correcting, ask if you’re teaching or just venting. Only one of those helps your dog.",
    icon: "🔎"
  },
  {
    id: 216,
    title: "Imagine Their Senses",
    tip: "Dogs live in a world of scent and sound layers we barely notice. Factoring that in makes you more patient.",
    icon: "🌍"
  },
  {
    id: 217,
    title: "Share Success",
    tip: "Pause after wins. Let both of you feel the satisfaction instead of rushing past it.",
    icon: "🌅"
  },
  {
    id: 218,
    title: "Give Yourself Grace",
    tip: "You’re learning too. Adjust, repair, and move on instead of beating yourself up.",
    icon: "🌼"
  },
  {
    id: 219,
    title: "End the Day with Thanks",
    tip: "Before bed, acknowledge one thing you appreciated about your dog. It shifts your mindset and how you show up tomorrow.",
    icon: "🌙"
  },
  {
    id: 220,
    title: "Love Is Your Best Tool",
    tip: "Technique matters, but real, steady care is what makes it work. Dogs feel intent.",
    icon: "💖"
  },

  // 🏡 Daily Life & Structure (221–280)

  {
    id: 221,
    title: "Calm Bookends to the Day",
    tip: "Start and finish the day with predictable, low-energy routines. This anchors your dog’s nervous system and keeps life from feeling chaotic.",
    icon: "🌅"
  },
  {
    id: 222,
    title: "Routines Build Security",
    tip: "Regular times for meals, walks, and rest help your dog relax because they know what to expect. Predictability lowers baseline anxiety.",
    icon: "🕰️"
  },
  {
    id: 223,
    title: "Structure Before Freedom",
    tip: "Teach boundaries, manners, and recall before offering big freedoms. Freedom without structure is what gets dogs in trouble.",
    icon: "🗝️"
  },
  {
    id: 224,
    title: "Mindful Morning Walk",
    tip: "Use the first walk as a reset: no phone, no rush. Just you, your dog, and a calm pace to set the tone for the day.",
    icon: "🚶"
  },
  {
    id: 225,
    title: "Leash On Only When Calm",
    tip: "If your dog explodes when they see the leash, wait for at least one moment of stillness before clipping. You’re rehearsing the state you want on the walk.",
    icon: "🦮"
  },
  {
    id: 226,
    title: "Doorway Patience",
    tip: "Ask your dog to sit or stand calmly before doors open. Over time, rushing the threshold simply stops being part of their routine.",
    icon: "🚪"
  },
  {
    id: 227,
    title: "Safe Feeding Timing",
    tip: "Avoid heavy activity right after big meals, especially in large, deep-chested breeds. This small habit supports digestive health and comfort.",
    icon: "🍽️"
  },
  {
    id: 228,
    title: "Turn Meals into Training",
    tip: "Use part of each meal as rewards for beds, sits, or recalls. You’re feeding both body and brain without overdoing treats.",
    icon: "🍗"
  },
  {
    id: 229,
    title: "Multiple Cozy Spots",
    tip: "Offer more than one safe resting place so your dog can choose where they feel comfortable. Choice helps them self-regulate.",
    icon: "🛏️"
  },
  {
    id: 230,
    title: "Protect Quiet Time",
    tip: "Block off parts of the day where nothing is demanded of your dog. Over-scheduled dogs burn out just like people.",
    icon: "😴"
  },
  {
    id: 231,
    title: "Walk for Quality, Not Distance",
    tip: "A shorter, structured, sniffy walk is better than a frantic long one. Focus on connection, not just steps.",
    icon: "🐾"
  },
  {
    id: 232,
    title: "Mix Mental with Physical",
    tip: "Pair physical exercise with simple training or scent work. Mental fatigue smooths out edgy energy.",
    icon: "🧠"
  },
  {
    id: 233,
    title: "Weather-Smart Outings",
    tip: "Check heat, cold, and footing before heading out. A comfortable dog is more able to listen and enjoy.",
    icon: "🌡️"
  },
  {
    id: 234,
    title: "Consistent Leash Expectations",
    tip: "If you sometimes allow pulling and sometimes don’t, your dog never really learns. Decide your standard and stick with it.",
    icon: "📏"
  },
  {
    id: 235,
    title: "Polite Greetings at Home",
    tip: "Teach your dog that visitors only give attention when all four paws are on the floor or they’re sitting. Simple rule, big payoff.",
    icon: "🙌"
  },
  {
    id: 236,
    title: "Play with Boundaries",
    tip: "Even fun has rules: no teeth on skin, respond to 'enough,' drop the toy when asked. This keeps everyone safe and relaxed.",
    icon: "🧩"
  },
  {
    id: 237,
    title: "Bedtime Signals",
    tip: "Use the same soft cues at night — dim lights, quiet voices, slow movements. Your dog learns these mean it’s time to settle.",
    icon: "🌙"
  },
  {
    id: 238,
    title: "Daily Place Practice",
    tip: "Rehearse 'place' for short periods each day so your dog can reliably relax on cue during busy moments.",
    icon: "🛋️"
  },
  {
    id: 239,
    title: "Unified Household Rules",
    tip: "Make sure everyone uses the same rules for furniture, jumping, and food. Inconsistency from humans creates confusion in dogs.",
    icon: "👨‍👩‍👧‍👦"
  },
  {
    id: 240,
    title: "Use Transitions as Training",
    tip: "Ask for quick behaviors before going outside, getting in the car, or starting play. These add structure without needing extra time.",
    icon: "🔑"
  },
  {
    id: 241,
    title: "Calm Feeding Ritual",
    tip: "If your dog is frantic at mealtime, wait quietly until they pause, then lower the bowl. You’re teaching that calm brings food.",
    icon: "🥣"
  },
  {
    id: 242,
    title: "Manage Freedom Indoors",
    tip: "Until your dog proves trustworthy, use gates, pens, or leashes. This prevents rehearsed bad habits and protects your stuff.",
    icon: "🚧"
  },
  {
    id: 243,
    title: "Reinforce House Manners",
    tip: "When your dog is resting, not counter-surfing, or calmly watching, occasionally reward. You’re paying the behaviors you want more of.",
    icon: "📸"
  },
  {
    id: 244,
    title: "Morning Stretch Ritual",
    tip: "Encourage a gentle stretch or slow first walk. It’s kinder to joints and sets a calmer tone for the day.",
    icon: "🤸"
  },
  {
    id: 245,
    title: "Avoid Over-Scheduling",
    tip: "Too many dog park days, errands, and guests can fry your dog’s nerves. Leave recovery days in the week.",
    icon: "🛋️"
  },
  {
    id: 246,
    title: "Controlled Choices",
    tip: "Offer your dog safe choices like which toy or which side of the street, while keeping rules the same. This builds confidence without chaos.",
    icon: "🗺️"
  },
  {
    id: 247,
    title: "Pause Between Activities",
    tip: "Insert short calm breaks between play, training, and walks. Tiny resets prevent one big arousal spike.",
    icon: "⏸️"
  },
  {
    id: 248,
    title: "Keep Cues Simple",
    tip: "Use short, distinct words and avoid long speeches. Clarity beats cleverness.",
    icon: "💬"
  },
  {
    id: 249,
    title: "Celebrate Smooth Routines",
    tip: "If your day runs with calm exits, relaxed walks, and quiet evenings, recognize that. That’s the result of all your structure.",
    icon: "🎉"
  },
  {
    id: 250,
    title: "Use Indoor Leash for Guidance",
    tip: "Clipping a light leash inside during busy times gives you gentle control without grabbing. It’s management, not punishment.",
    icon: "🏠"
  },
  {
    id: 251,
    title: "Secure the Environment When Out",
    tip: "Before leaving, remove temptations and ensure your dog is in a safe space. Good setups prevent bad surprises.",
    icon: "🧯"
  },
  {
    id: 252,
    title: "Low-Key Arrivals",
    tip: "When you come home, ignore wild behavior until your dog relaxes, then greet. You’re teaching them that calm gets your attention.",
    icon: "🔄"
  },
  {
    id: 253,
    title: "Respect Mealtime Space",
    tip: "Show your dog that hands near the bowl aren’t a threat, but don’t pester them while they eat. Balanced handling prevents food issues.",
    icon: "🍛"
  },
  {
    id: 254,
    title: "Keep Communication Clear",
    tip: "Avoid stacking multiple cues or nagging. One request, then guidance, keeps language meaningful.",
    icon: "🔊"
  },
  {
    id: 255,
    title: "Daily Check-In Walk",
    tip: "Take one walk just to observe your dog’s mood and behavior. Use it as your gauge for how much structure or support they need.",
    icon: "🌤️"
  },
  {
    id: 256,
    title: "Teach Car Manners",
    tip: "Rehearse waiting at the car door and only jumping in or out on cue. This simple habit prevents dangerous lunges into traffic.",
    icon: "🚗"
  },
  {
    id: 257,
    title: "Reinforce Healthy Independence",
    tip: "If your dog can nap alone calmly, occasionally reward that. You’re encouraging emotional balance, not clinginess.",
    icon: "🌻"
  },
  {
    id: 258,
    title: "Toy Rotation System",
    tip: "Keep a stash of toys and swap them out weekly. Variety stimulates curiosity without overbuying.",
    icon: "🧸"
  },
  {
    id: 259,
    title: "Coach Your Guests",
    tip: "Ask visitors to ignore your dog until all four paws are down. Protecting your rules keeps your dog from backsliding.",
    icon: "🧍‍♀️"
  },
  {
    id: 260,
    title: "Watch Energy Swings",
    tip: "If energy suddenly spikes indoors, switch to calm games, chews, or 'place.' Catch it early before it becomes chaos.",
    icon: "⚡"
  },
  {
    id: 261,
    title: "Guard the Rest Zone",
    tip: "Make your dog’s bed or crate a no-interruption area. Everyone in the home should honor it.",
    icon: "🪺"
  },
  {
    id: 262,
    title: "Use Positive Directions",
    tip: "Instead of 'no,' give a clear alternative like 'on your bed.' It tells your dog exactly how to succeed.",
    icon: "🎯"
  },
  {
    id: 263,
    title: "Slow Door Handling",
    tip: "Open doors slowly and in control. Rushed movements fuel door-darting and frenzy.",
    icon: "🚪"
  },
  {
    id: 264,
    title: "Tight Space Manners",
    tip: "Practice calm sits and quiet behavior in elevators, hallways, or vet lobbies. These habits prevent collisions and stress.",
    icon: "🛗"
  },
  {
    id: 265,
    title: "Schedule Enrichment Blocks",
    tip: "Plan 5–10 minutes for puzzles or sniff games most days. Mental outlets are as important as walks.",
    icon: "🧩"
  },
  {
    id: 266,
    title: "Train While You Clean",
    tip: "Use chores as a backdrop for stays, place, and calm coexistence. It normalizes your dog being settled around activity.",
    icon: "🧹"
  },
  {
    id: 267,
    title: "Match Exercise to the Dog",
    tip: "A young shepherd and an older pug should not have the same routine. Tailor activity to age, breed, and health.",
    icon: "🐕"
  },
  {
    id: 268,
    title: "Spot Over-Tired Signals",
    tip: "Zoomies, nipping, and ignoring cues can mean your dog is done, not defiant. Respond with rest, not more stimulation.",
    icon: "😴"
  },
  {
    id: 269,
    title: "Calm Night Routine",
    tip: "Wind down with slower movement, softer sounds, and maybe a chew or massage. Predictable calm makes sleep easier.",
    icon: "🕯️"
  },
  {
    id: 270,
    title: "Teach Stair Confidence",
    tip: "Guide puppies and seniors slowly on stairs. One bad slip can cause long-term fear or pain.",
    icon: "🪜"
  },
  {
    id: 271,
    title: "Mini Training on Walks",
    tip: "Drop in sits, downs, and eye contact along the route. It keeps your dog mentally with you, not just physically.",
    icon: "👀"
  },
  {
    id: 272,
    title: "Use Sound to Soothe",
    tip: "Soft music or white noise can help many dogs settle during alone time or storms. Experiment with what calms yours.",
    icon: "🎵"
  },
  {
    id: 273,
    title: "Guard Indoor Energy",
    tip: "Encourage calmer movement inside so your dog learns to save high arousal for outside play.",
    icon: "🕯️"
  },
  {
    id: 274,
    title: "Plan Nothing Time",
    tip: "Build in chunks where you’re home but not entertaining your dog. They learn to self-settle instead of demanding constant engagement.",
    icon: "🧘"
  },
  {
    id: 275,
    title: "Teach Guest Guidelines",
    tip: "A 30-second briefing to visitors about ignoring jumping or following your rules protects months of training.",
    icon: "🗣️"
  },
  {
    id: 276,
    title: "Feed in Peace",
    tip: "Use calm, separate feeding spots in multi-dog homes. This reduces tension and resource guarding.",
    icon: "🍲"
  },
  {
    id: 277,
    title: "Leash Ready by the Door",
    tip: "Keep gear organized so pre-walk time stays calm instead of rushed and frantic. Your setup influences the energy.",
    icon: "🪝"
  },
  {
    id: 278,
    title: "Interrupt Chaos Loops",
    tip: "If the energy spirals, stop, reset everyone, and restart with structure. Don’t just ride it out.",
    icon: "🔁"
  },
  {
    id: 279,
    title: "Plan Rest After Work",
    tip: "After training or big outings, intentionally lower stimulation. The nervous system needs recovery time.",
    icon: "😌"
  },
  {
    id: 280,
    title: "End the Day with Reassurance",
    tip: "A calm word, gentle touch, or short bonding moment at night tells your dog all is well in their world.",
    icon: "🤲"
  },

  // 🩺 Health, Touch & Physical Care (281–320)

  {
    id: 281,
    title: "Daily Body Check",
    tip: "Run your hands along your dog’s body to feel for bumps, scabs, heat, or soreness. Catching small changes early can prevent bigger health or behavior issues.",
    icon: "✋"
  },
  {
    id: 282,
    title: "Nightly Massage Ritual",
    tip: "Use slow, gentle pressure along muscles and joints at the end of the day. It relaxes their body, lowers stress, and strengthens your bond.",
    icon: "🤲"
  },
  {
    id: 283,
    title: "Warm Up Before Intense Play",
    tip: "Start with a short walk or light movement before sprints, fetch, or agility. Warm muscles are less prone to strain.",
    icon: "🤸"
  },
  {
    id: 284,
    title: "Hydration Awareness",
    tip: "Offer water after walks, training, or play, especially in heat. Even mild dehydration can affect mood, focus, and recovery.",
    icon: "💧"
  },
  {
    id: 285,
    title: "Prioritize Sleep",
    tip: "Dogs need far more sleep than we do — often 16+ hours for puppies and 12+ for adults. Guard their rest like you guard their food.",
    icon: "😴"
  },
  {
    id: 286,
    title: "Keep Them Lean",
    tip: "Extra weight stresses joints and organs and often makes dogs less tolerant and more uncomfortable. A fit dog moves, trains, and feels better.",
    icon: "⚖️"
  },
  {
    id: 287,
    title: "Paw & Nail Care",
    tip: "Short nails support good posture and pain-free movement. Normalize gentle handling of paws and reinforce calmly.",
    icon: "🐾"
  },
  {
    id: 288,
    title: "Ear Checks",
    tip: "Regularly inspect ears for redness, smell, or buildup. Discomfort here can show up as irritability long before obvious symptoms.",
    icon: "👂"
  },
  {
    id: 289,
    title: "Grooming as Bonding",
    tip: "Use brushing and grooming as quiet connection time instead of a rushed chore. Move slowly and reward tolerance.",
    icon: "🧴"
  },
  {
    id: 290,
    title: "Eye Care Matters",
    tip: "Wipe away gentle discharge and watch for squinting or redness. Eye discomfort can make your dog snappy or withdrawn.",
    icon: "👁️"
  },
  {
    id: 291,
    title: "Dental Health",
    tip: "Healthy teeth and gums prevent chronic pain that often goes unnoticed. Chews, brushing, or dental rinses all help.",
    icon: "🦷"
  },
  {
    id: 292,
    title: "Paw Inspections After Walks",
    tip: "Check pads for cuts, stickers, or ice melt. Sore feet change gait and mood quickly.",
    icon: "🐕‍🦺"
  },
  {
    id: 293,
    title: "Heat Safety",
    tip: "Avoid hot pavement, limit midday exercise, and watch for excessive panting. Overheating can turn a good dog into a panicked one fast.",
    icon: "🌡️"
  },
  {
    id: 294,
    title: "Comfortable Grooming Setup",
    tip: "Use non-slip surfaces and have treats ready. Predictable, kind grooming reduces fear for life.",
    icon: "🧰"
  },
  {
    id: 295,
    title: "Vet Prep at Home",
    tip: "Practice being gently restrained, having ears and mouth checked, and standing on a mat. Familiar patterns lower vet visit stress.",
    icon: "🏥"
  },
  {
    id: 296,
    title: "Soft Voice During Care",
    tip: "During baths, nail trims, or treatments, keep your voice low and soothing. Your tone can either calm or spike anxiety.",
    icon: "🎶"
  },
  {
    id: 297,
    title: "Joint-Friendly Flooring",
    tip: "Use runners or rugs on slippery floors, especially for seniors or big dogs. Secure footing supports confidence and comfort.",
    icon: "🪄"
  },
  {
    id: 298,
    title: "Adjust for Aging",
    tip: "Shorter walks, more rest, ramps, and supportive beds help senior dogs stay engaged without pain.",
    icon: "🧓"
  },
  {
    id: 299,
    title: "Massage for Recovery",
    tip: "Light massage after hard exercise can reduce stiffness and support healthy circulation. Keep touch slow and watch your dog’s feedback.",
    icon: "💆"
  },
  {
    id: 300,
    title: "Temperature Comfort",
    tip: "Offer shade, fans, sweaters, or blankets depending on the season and your dog’s coat. Being physically comfortable supports emotional regulation.",
    icon: "🧊"
  },
  {
    id: 301,
    title: "Recognize Pain Signals",
    tip: "Growling, snapping, avoiding stairs, or not wanting to be touched can all be pain, not 'bad behavior.' Always rule out medical causes.",
    icon: "🩹"
  },
  {
    id: 302,
    title: "Practice Consent Touch",
    tip: "Pause mid-petting to see if your dog leans in or moves away. Listening to their answer deepens trust.",
    icon: "🕊️"
  },
  {
    id: 303,
    title: "Set Up Calm Bath Time",
    tip: "Gather everything before you start and move at your dog’s pace. Less wrestling, more teamwork.",
    icon: "🛁"
  },
  {
    id: 304,
    title: "Check Gear Fit Often",
    tip: "Too-tight harnesses rub; too-loose ones shift and annoy. Good fit prevents both escape and discomfort-based behavior.",
    icon: "🎽"
  },
  {
    id: 305,
    title: "Use Ear Rubs to Relax",
    tip: "Slowly rubbing the base of the ears can be deeply soothing. It’s a great tool for winding down in the evening.",
    icon: "🫶"
  },
  {
    id: 306,
    title: "Match Activity to Capacity",
    tip: "Some dogs spin out if over-exercised, others if under-exercised. Watch your dog’s behavior to find their ideal balance.",
    icon: "⚖️"
  },
  {
    id: 307,
    title: "Gentle Face Cleaning",
    tip: "Normalizing brief, gentle wipes around eyes and mouth prevents discomfort and teaches trust in close handling.",
    icon: "🧼"
  },
  {
    id: 308,
    title: "Respect Healing Time",
    tip: "After injury or surgery, shift to low-impact enrichment instead of pushing physical activity. Healing first, conditioning later.",
    icon: "🏡"
  },
  {
    id: 309,
    title: "Yearly Wellness Checks",
    tip: "Regular vet checks catch silent issues that may appear only as behavior changes. Don’t skip them.",
    icon: "📅"
  },
  {
    id: 310,
    title: "Parasite Protection",
    tip: "Use appropriate preventatives so your dog isn’t fighting discomfort or disease in the background.",
    icon: "🪲"
  },
  {
    id: 311,
    title: "Manage Seasonal Allergies",
    tip: "If your dog licks paws or scratches more in certain months, wipe them down after walks and talk with your vet about relief options.",
    icon: "🌸"
  },
  {
    id: 312,
    title: "Reevaluate Diet Regularly",
    tip: "As age, activity, or seasons shift, your dog’s nutritional needs do too. Adjust thoughtfully to support stable energy and mood.",
    icon: "🥗"
  },
  {
    id: 313,
    title: "Normalize Handling",
    tip: "Short, positive collar grabs and gentle restraint practice make emergencies less scary later.",
    icon: "🪞"
  },
  {
    id: 314,
    title: "Cool Down After Play",
    tip: "End intense fetch or running with a few minutes of easy walking. It lets body and brain settle before rest.",
    icon: "🫀"
  },
  {
    id: 315,
    title: "Short Grooming Sessions",
    tip: "Do multiple short, positive grooming sessions instead of one long battle. Always stop while your dog is still coping well.",
    icon: "⏱️"
  },
  {
    id: 316,
    title: "Use Your Scent as Comfort",
    tip: "A worn T-shirt in their bed can help ease separation for sensitive dogs. Familiar scent acts like a safety blanket.",
    icon: "👕"
  },
  {
    id: 317,
    title: "Extra Care for Seniors",
    tip: "Celebrate older dogs with softer routines, extra warmth, and patience. They’re doing life with a body that’s working harder now.",
    icon: "👴"
  },
  {
    id: 318,
    title: "Paw Balm Routine",
    tip: "After rough terrain or winter walks, massage balm into pads. It protects skin and becomes a soothing ritual.",
    icon: "🧴"
  },
  {
    id: 319,
    title: "Watch Their Breathing",
    tip: "Heavy panting at rest, coughing, or odd rhythms are flags. Trust what you see and get it checked.",
    icon: "🫁"
  },
  {
    id: 320,
    title: "Touch as Therapy",
    tip: "Slow, intentional petting can lower blood pressure and tension in both of you. Use it as a daily reset, not just a casual habit.",
    icon: "❤️"
  },

  // 🌿 Enrichment & Exploration (321–365)

  {
    id: 321,
    title: "Let Them Sniff",
    tip: "Sniffing is how your dog reads the world. Building in sniff time on walks turns a boring route into rich mental stimulation.",
    icon: "👃"
  },
  {
    id: 322,
    title: "Meal as Enrichment",
    tip: "Use puzzle feeders, snuffle mats, or scatter feeding to make your dog work a little for food. It slows them down and satisfies natural foraging instincts.",
    icon: "🥣"
  },
  {
    id: 323,
    title: "Hide-and-Seek Treats",
    tip: "Hide small treats around a room and encourage your dog to search. This boosts confidence, independence, and nose skills.",
    icon: "🔎"
  },
  {
    id: 324,
    title: "Challenge Under Threshold",
    tip: "Offer new items, surfaces, or environments that stretch your dog just slightly, not so much that they shut down. Reward curiosity and calm engagement heavily.",
    icon: "🌱"
  },
  {
    id: 325,
    title: "Teach 'Find It'",
    tip: "Toss a treat and say 'Find it!' until your dog loves the game. Later you can hide food or toys and use the same cue for focused scent work.",
    icon: "🐽"
  },
  {
    id: 326,
    title: "One New Thing a Day",
    tip: "A new route, object, scent, or small challenge each day keeps your dog mentally flexible without overwhelming them.",
    icon: "🧩"
  },
  {
    id: 327,
    title: "DIY Puzzles",
    tip: "Use boxes, towels, muffin tins, and safe recyclables to create low-cost puzzles. Always supervise so curiosity stays safe.",
    icon: "📦"
  },
  {
    id: 328,
    title: "Puzzle Feeder Dinners",
    tip: "Swap the bowl for a puzzle feeder sometimes. Your dog burns mental energy while eating the same amount of food.",
    icon: "🍗"
  },
  {
    id: 329,
    title: "Rotate Toys",
    tip: "Keep some toys put away and reintroduce them later. This keeps interest high without constant new purchases.",
    icon: "🔄"
  },
  {
    id: 330,
    title: "Jobs for Working Minds",
    tip: "Give high-drive or working breeds real tasks like carrying, searching, or structured games. Meeting their mental needs reduces problem behaviors.",
    icon: "🐕‍🦺"
  },
  {
    id: 331,
    title: "Scent Work Confidence",
    tip: "Start with easy hides and let your dog win big. Scent success is especially powerful for insecure dogs.",
    icon: "🌿"
  },
  {
    id: 332,
    title: "Grass Foraging",
    tip: "Scatter a portion of kibble in the grass and let your dog sniff it out. It’s simple, calming, and instinct-satisfying.",
    icon: "🍀"
  },
  {
    id: 333,
    title: "Quiet Park Adventures",
    tip: "Explore new parks or paths during low-traffic times. Calm novelty expands their world safely.",
    icon: "🌳"
  },
  {
    id: 334,
    title: "Encourage Problem Solving",
    tip: "With safe puzzles, resist helping immediately. Let your dog experiment — figuring it out builds resilience.",
    icon: "🧠"
  },
  {
    id: 335,
    title: "Surface Confidence Walks",
    tip: "Guide your dog over different safe surfaces like mats, boards, or gravel. This builds body awareness and confidence.",
    icon: "🦶"
  },
  {
    id: 336,
    title: "Short Novelty Sessions",
    tip: "Keep new experiences brief and end while your dog is still coping well. That’s how you grow curiosity instead of avoidance.",
    icon: "🚶‍♂️"
  },
  {
    id: 337,
    title: "Bring Nature Home",
    tip: "Offer pinecones, leaves, or branches for your dog to smell and explore. It brings the outside world in on slow days.",
    icon: "🌲"
  },
  {
    id: 338,
    title: "Blend Training with Play",
    tip: "Ask for sits, downs, or touches in between throws or tugs. Your dog learns that listening is part of the fun, not separate from it.",
    icon: "⚽"
  },
  {
    id: 339,
    title: "Frozen Treat Projects",
    tip: "Stuff and freeze safe chews or toys with wet food or broth. They cool, calm, and occupy your dog at the same time.",
    icon: "🧊"
  },
  {
    id: 340,
    title: "Dig Box Freedom",
    tip: "Provide a sand or dirt box where digging is allowed. Bury toys or treats so your dog can dig legally.",
    icon: "🪣"
  },
  {
    id: 341,
    title: "Find the Favorite Toy",
    tip: "Hide a beloved toy somewhere simple and encourage your dog to hunt. Increase difficulty as they get better.",
    icon: "💎"
  },
  {
    id: 342,
    title: "Window Watching Safely",
    tip: "Let your dog watch the world from a calm distance, and block views if it becomes a barking trigger. Observation can be enrichment if it stays neutral.",
    icon: "🪟"
  },
  {
    id: 343,
    title: "Slow Exploration Walks",
    tip: "Take some walks where the point is wandering and sniffing, not covering distance. This style of walk deeply satisfies many dogs.",
    icon: "🕊️"
  },
  {
    id: 344,
    title: "Change Up Routes",
    tip: "Rotate where you walk to offer new scents and sights. Novelty keeps your dog mentally engaged and adaptable.",
    icon: "🗺️"
  },
  {
    id: 345,
    title: "Indoor Texture Trails",
    tip: "Lay out towels, mats, cardboard, or pillows with treats hidden. Let your dog follow their nose and feet.",
    icon: "🧺"
  },
  {
    id: 346,
    title: "Rainy Day Adventures",
    tip: "If your dog is comfortable, let them experience short, fun walks in the rain. Keep it light and rewarding.",
    icon: "☔"
  },
  {
    id: 347,
    title: "Parallel Walk Socialization",
    tip: "Walk alongside another calm dog with space instead of forcing greetings. It’s rich social exposure without pressure.",
    icon: "🐾"
  },
  {
    id: 348,
    title: "Evening Sniffari",
    tip: "Before bed, use a longer line or quiet path and let your dog sniff at their pace. It helps them decompress from the day.",
    icon: "🌙"
  },
  {
    id: 349,
    title: "Senior Dog Enrichment",
    tip: "Use low-impact scent games and soft puzzles to keep older dogs mentally stimulated without stressing their bodies.",
    icon: "👴"
  },
  {
    id: 350,
    title: "Indoor Obstacle Fun",
    tip: "Create tunnels, cavalettis, or step-overs with safe household items. Confidence and coordination can be built in small spaces.",
    icon: "🪑"
  },
  {
    id: 351,
    title: "Engage All Senses",
    tip: "Incorporate sound, scent, texture, and gentle challenges. Varied sensory input keeps your dog’s world rich.",
    icon: "🎧"
  },
  {
    id: 352,
    title: "Safe Off-Leash Time",
    tip: "Use fenced fields or long lines to give more freedom while staying safe. True decompression happens when dogs can move freely.",
    icon: "🦴"
  },
  {
    id: 353,
    title: "Train on the Go",
    tip: "Practice basic cues in new locations so your dog learns that listening travels with them. The world becomes their classroom.",
    icon: "🚶‍♀️"
  },
  {
    id: 354,
    title: "Nature Reset Trips",
    tip: "Quiet hikes, forest walks, or beach visits help both of you regulate. Natural spaces are nervous system medicine.",
    icon: "🌊"
  },
  {
    id: 355,
    title: "Rainy Day Treasure Hunts",
    tip: "Hide food or toys around the house and let your dog work to find them. This burns energy when outdoor options are limited.",
    icon: "🏠"
  },
  {
    id: 356,
    title: "Encourage Healthy Self-Amusement",
    tip: "Offer safe chews and puzzle toys so your dog learns how to settle and entertain themselves without constant input from you.",
    icon: "🧸"
  },
  {
    id: 357,
    title: "Watch What They Love",
    tip: "Notice whether your dog lights up for sniffing, toys, tug, or digging. Build enrichment around their favorite things.",
    icon: "🧭"
  },
  {
    id: 358,
    title: "Household Object Games",
    tip: "Use muffin tins, cups, and boxes to design new puzzle challenges. Rotate setups to keep their brain guessing.",
    icon: "🎁"
  },
  {
    id: 359,
    title: "Let Them Lead Sometimes",
    tip: "On a safe route, give your dog a few minutes to choose the direction. Shared choice increases trust and reduces resistance.",
    icon: "🦮"
  },
  {
    id: 360,
    title: "Reward Calm Exploration",
    tip: "If your dog investigates new things with a loose body and soft curiosity, quietly reward. You’re reinforcing bravery without push.",
    icon: "🌼"
  },
  {
    id: 361,
    title: "Theme Weeks for Fun",
    tip: "Try dedicated weeks like 'sniff week,' 'trick week,' or 'confidence week' to keep yourself creative and your dog engaged.",
    icon: "📅"
  },
  {
    id: 362,
    title: "Body Awareness Games",
    tip: "Teach your dog to back up, step over poles, or place paws on targets. These games improve coordination and confidence.",
    icon: "🔄"
  },
  {
    id: 363,
    title: "Rainy Day Brain Work",
    tip: "On days you skip big walks, lean into trick training, shaping games, or scent work. Mental exercise fills the gap.",
    icon: "🧩"
  },
  {
    id: 364,
    title: "Quiet Shared Adventures",
    tip: "A simple, slow walk or park bench hangout with no agenda can be deeply bonding. Not all enrichment has to be loud.",
    icon: "🌄"
  },
  {
    id: 365,
    title: "Exploration Deepens Bond",
    tip: "Every safe new experience you guide your dog through teaches them that you’re reliable in unfamiliar situations. That trust is priceless.",
    icon: "❤️"
  }

];

// Function to get a random tip
export const getRandomTip = () => {
  const randomIndex = Math.floor(Math.random() * trainingTips.length);
  return trainingTips[randomIndex];
};

// Function to get next tip in sequence
export const getNextTip = (currentTipId) => {
  const currentIndex = trainingTips.findIndex(tip => tip.id === currentTipId);
  const nextIndex = (currentIndex + 1) % trainingTips.length;
  return trainingTips[nextIndex];
};

// Function to get previous tip
export const getPreviousTip = (currentTipId) => {
  const currentIndex = trainingTips.findIndex(tip => tip.id === currentTipId);
  const previousIndex = currentIndex === 0 ? trainingTips.length - 1 : currentIndex - 1;
  return trainingTips[previousIndex];
};
